<app-pencil-button
  #dropdownButton
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
  class="dropdown-button"
  [class.open]="isMenuOpen"
  [disabled]="disabled"
  buttonType="button"
  (menuClosed)="onMenuClosed()"
  (menuOpened)="onMenuOpened()"
>
  <span class="button-content">
    {{ selectedOption?.value || placeholder | truncateString: maxOptionLength }}
    <app-pencil-icon
      [name]="'keyboard_arrow_down'"
      [type]="IconTypes.matIcon"
      class="arrow-icon"
    ></app-pencil-icon>
  </span>
</app-pencil-button>

<mat-menu #menu="matMenu" [class]="'dropdown-options-menu'">
  <div class="menu-container">
    <app-pencil-button
      class="menu-item"
      *ngFor="let option of options"
      (clickEvent)="onOptionSelected(option)"
      [selected]="option.id === selectedOption?.id"
    >
      <span>{{ option.value | truncateString: maxOptionLength }}</span>
      <app-pencil-icon
        name="check"
        type="mat-icon"
        *ngIf="option.id === selectedOption?.id"
      ></app-pencil-icon>
    </app-pencil-button>
  </div>
</mat-menu>
